export enum RequestTypes {
    TRAVEL = 'travel',
    PAYMENT = 'payment',
    STIPEND = 'stipend',
    REIMBURSEMENT = 'out-of-pocket',
}

/**
 * @deprecated Use RequestType from V2 folder instead.
 */
export enum RequestTypesKeys {
    TRAVEL = 'Travel',
    STIPEND = 'Stipend',
    REIMBURSEMENT = 'Reimbursement',
}
